<template>
  <div class="wizard-body w-[75%] flex-shrink-0 flex-grow-0 max-w-[75%]">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP.DESC')"
    />
    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <!--
        Sibling `<label for>` rather than a wrapper: the branded control is a button, and a
        wrapping label names inputs, not buttons. The `label` prop carries the same string to
        the accessible name.
      -->
      <label for="whatsapp-provider">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.LABEL') }}
      </label>
      <woot-select
        id="whatsapp-provider"
        v-model="provider"
        :options="providerOptions"
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.LABEL')"
      />
    </div>

    <twilio v-if="provider === 'twilio'" type="whatsapp" />
    <three-sixty-dialog-whatsapp v-else-if="provider === '360dialog'" />
    <cloud-whatsapp v-else />
  </div>
</template>

<script>
import PageHeader from '../../SettingsSubPageHeader.vue';
import Twilio from './Twilio.vue';
import ThreeSixtyDialogWhatsapp from './360DialogWhatsapp.vue';
import CloudWhatsapp from './CloudWhatsapp.vue';
import WootSelect from 'dashboard/components/ui/Select.vue';

export default {
  components: {
    PageHeader,
    Twilio,
    ThreeSixtyDialogWhatsapp,
    CloudWhatsapp,
    WootSelect,
  },
  data() {
    return {
      provider: 'whatsapp_cloud',
    };
  },
  computed: {
    // Every value here is a STRING and has to stay one. `provider` picks the sub-form by
    // `===`, and the same three tokens are the `provider` the created channel is stored
    // under — a number or a boolean in this field would open the wrong wizard and write a
    // channel Meta could not be talked to through.
    providerOptions() {
      return [
        {
          value: 'whatsapp_cloud',
          label: this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.WHATSAPP_CLOUD'),
        },
        {
          value: 'twilio',
          label: this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.TWILIO'),
        },
        {
          value: '360dialog',
          label: this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.360_DIALOG'),
        },
      ];
    },
  },
};
</script>
